// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"polyfills-dom":"0c0cb51de5ba72a0","polyfills-core-js":"28b0a127a5558ce2","node_modules_wizsolucoes_wiz-privacy_dist_esm_wiz-privacy_entry_js":"dcc7a3a07085d25b"}[chunkId] + ".js";
};